import { BaseTag } from 'mixs/base/base_mixin';
import RiotEventManager   from 'utilities/riot/event_manager';
import {
  PLANNER_CHANGE_STATUS,
  PLANNER_CHANGE_UNDER
} from 'apps/events';
class OrdersInfo extends BaseTag {
  eventManager: RiotEventManager;
  init(){
    super.init();
    this.eventManager = new RiotEventManager(this)
    this.eventManager.customEvent(PLANNER_CHANGE_STATUS,       (e) => { this.onChangeStatus(e) })
    this.eventManager.customEvent(PLANNER_CHANGE_UNDER,        (e) => { this.onChangeUnder(e) })
  }
  onChangeStatus(e){
    let formTag = <any>this.tags['forms-orders-status'];
    formTag.submit();
  }
  onChangeUnder(e){
    let formTag = <any>this.tags['forms-orders-under'];
    formTag.submit();
  }
}
riot.mixin('orders.info', OrdersInfo as riot.TagMixin)
